const guestEn: Record<string, string> = {
  "guest.header.venueFallback": "Venue",
  "guest.header.help": "Help",
  "guest.language.label": "Language",
  "guest.legal.terms": "Terms and conditions",
  "guest.legal.privacy": "Privacy policy",
  "guest.help.title": "Help",
  "guest.help.body": "We’ve notified your waiter. If you still need help, close this message and let them know.",
  "guest.loading": "Loading data…",
  "guest.payment.success.title": "Payment successful, thank you!",
  "guest.payment.success.remaining": "Remaining to pay: {amount} {currency}",
  "guest.payment.success.allPaid": "Everything is paid. Thank you!",
  "guest.payment.cta.done": "Skip",
  "guest.payment.cta.another": "Add payment",
  "guest.payment.cta.share": "Share link",
  "guest.payment.cta.emptyCartAndPay": "Pay now",
  "guest.payment.cta.continue": "Continue",
  "guest.payment.cta.chooseAmount": "Choose amount",
  "guest.payment.cta.continueToTip": "Continue to tips",
  "guest.payment.cta.continueToPay": "Continue to pay",
  "guest.payment.cta.preparing": "Preparing…",
  "guest.feedback.header": "How did you find us?",
  "guest.feedback.body.lovedIt": "Loved it? Rate us in one tap.",
  "guest.feedback.body.improve": "Not perfect? Tell us privately.",
  "guest.feedback.cta.publicReview": "Loved it ⭐⭐⭐⭐⭐",
  "guest.feedback.cta.privateFeedback": "Tell us privately",
  "guest.feedback.socialProof": "{count}+ guests rated us 5★",
  "guest.feedback.source.question": "How did you find us?",
  "guest.feedback.source.google": "Google",
  "guest.feedback.source.instagram": "Instagram",
  "guest.feedback.source.tiktok": "TikTok",
  "guest.feedback.source.tripadvisor": "TripAdvisor",
  "guest.feedback.source.friends": "Friends",
  "guest.feedback.source.returning": "Returning",
  "guest.feedback.source.press": "Press",
  "guest.feedback.source.walkedBy": "Walked by",
  "guest.feedback.destination.choose": "Where would you like to leave a review?",
  "guest.feedback.secondary.title": "More places to review us",
  "guest.feedback.private.helper": "Opens your email app with a pre-filled message.",
  "guest.feedback.destination.email": "Email",
  "guest.feedback.destination.review": "Review",
  "guest.feedback.visitType.label": "Have you been here before?",
  "guest.feedback.visitType.firstTime": "First time",
  "guest.feedback.visitType.returning": "Returning",
  "guest.tabs.payment": "Payment",
  "guest.tabs.newPurchases": "New purchases",
  "guest.selection.title": "Your open bills",
  "guest.selection.subtitle": "Choose bills",
  "guest.selection.selectAll": "All",
  "guest.selection.clear": "Clear",
  "guest.selection.emptyOrders": "Here will be your orders",
  "guest.selection.notPayable": "All orders are not payable",
  "guest.intent.title": "Choose action",
  "guest.intent.addPositions": "Add items",
  "guest.intent.payAllPositions": "Pay full table",
  "guest.intent.payMyPositions": "Pay my items",
  "guest.intent.selectMyItemsTitle": "Select my items",
  "guest.intent.selectAllInOrder": "Select all: {orderLabel}",
  "guest.intent.clearSelection": "Clear",
  "guest.intent.paySelectedItems": "Pay selected items",
  "guest.intent.selectMyItemsEmpty": "No order items are available yet.",
  "guest.intent.itemsUnavailableReason": "Item composition is temporarily unavailable for this open order. Please ask a waiter to refresh the table before item-level payment.",
  "guest.intent.callWaiter": "Call waiter",
  "guest.intent.leaveTip": "Leave a tip",
  "guest.order.whose": "Who's order?",
  "guest.order.guestName": "Guest: {name}",
  "guest.order.newOrder": "New order",
  "guest.order.nameModal.title": "Who's order?",
  "guest.order.nameModal.placeholder": "Optional",
  "guest.loyalty.add": "Loyalty",
  "guest.loyalty.modalTitle": "Loyalty card",
  "guest.loyalty.visitOptional": "Loyalty card (optional)",
  "guest.loyalty.enterManually": "Enter card number manually",
  "guest.loyalty.lookupLabel": "Phone or loyalty card",
  "guest.loyalty.lookupMode.auto": "Auto detect",
  "guest.loyalty.lookupMode.phone": "Phone",
  "guest.loyalty.lookupMode.card": "Loyalty card",
  "guest.loyalty.lookupPlaceholder": "Phone (+...) or card number",
  "guest.loyalty.phonePlaceholder": "+37128712007",
  "guest.loyalty.placeholder": "8-24 digits",
  "guest.loyalty.formatHint": "Use 8-24 digits only.",
  "guest.loyalty.phoneFormatHint": "Use international format, e.g. +37128712007.",
  "guest.loyalty.lookupHint": "Enter phone or loyalty card number.",
  "guest.loyalty.lookupRequired": "Enter phone or loyalty card number.",
  "guest.loyalty.badgeMasked": "Loyalty {mask}",
  "guest.loyalty.current": "Current card: {mask}",
  "guest.loyalty.notSet": "Not linked",
  "guest.loyalty.change": "Change",
  "guest.loyalty.collapsible.prompt": "Have a loyalty card?",
  "guest.loyalty.collapsible.selected": "Loyalty: {mask}",
  "guest.loyalty.remove": "Remove",
  "guest.loyalty.sourceGuest": "Set by guest",
  "guest.loyalty.sourceStaff": "Set by waiter",
  "guest.loyalty.invalidFormat": "Card number must contain 8-24 digits.",
  "guest.loyalty.saveFailed": "Failed to save loyalty card.",
  "guest.loyalty.removeFailed": "Failed to remove loyalty card.",
  "guest.loyalty.error.tableNotLinked":
    "This table is not linked to POS yet. Ask staff to link the table and try again.",
  "guest.loyalty.error.placeNotFound": "This guest link is inactive. Ask staff for a new QR code.",
  "guest.loyalty.error.customerNotFound": "Loyalty customer was not found. Check phone/card and try again.",
  "guest.loyalty.applied": "Loyalty card linked.",
  "guest.loyalty.removed": "Loyalty card removed.",
  "guest.loyalty.saving": "Saving…",
  "guest.loyalty.scan": "Scan with camera",
  "guest.loyalty.scanStarting": "Starting camera…",
  "guest.loyalty.scanUnsupported": "Camera scanner is not supported in this browser.",
  "guest.loyalty.scanPermissionDenied": "Camera is unavailable. Check browser camera permissions.",
  "guest.loyalty.scanNoCard": "Could not detect a loyalty card number.",
  "guest.loyalty.scanAmbiguous": "Multiple loyalty numbers detected.",
  "guest.loyalty.scanSelectCandidate": "Choose the correct number below.",
  "guest.common.cancel": "Cancel",
  "guest.common.clear": "Clear",
  "guest.common.save": "Save",
  "guest.common.close": "Close",
  "guest.common.back": "Back",
  "guest.common.options": "Options",
  "guest.cart.inclOptions": "(incl options)",
  "guest.common.or": "or",
  "guest.status.partiallyPaid": "Partially paid",
  "guest.status.open": "Open",
  "guest.status.closed": "Closed",
  "guest.theme.label": "Theme",
  "guest.theme.system": "System",
  "guest.theme.light": "Light",
  "guest.theme.dark": "Dark",
  "guest.preorders.title": "Preorders",
  "guest.preorders.subtitle.table": "Table {tableLabel}",
  "guest.preorders.subtitle.fallback": "Orders you sent to the waiter",
  "guest.preorders.refresh": "Refresh",
  "guest.preorders.error.title": "Couldn’t load preorders.",
  "guest.preorders.error.linkInactive": "This link is no longer active.",
  "guest.preorders.error.loadFailed": "Failed to load preorders",
  "guest.preorders.loading": "Loading…",
  "guest.preorders.empty": "",
  "guest.preorders.status.pending": "In progress",
  "guest.preorders.status.approved": "Accepted by waiter",
  "guest.preorders.status.resolved": "Sent to POS",
  "guest.preorders.status.rejected": "Rejected",
  "guest.preorders.status.canceled": "Closed",
  "guest.preorders.sentAt": "Sent {time}",
  "guest.preorders.updatedAt": "Updated {time}",
  "guest.preorders.itemFallback": "Item",
  "guest.preorders.course": "Serving order {course}",
  "guest.preorders.noItems": "No items",
  "guest.scheduledVisit.success.title": "Preorder paid",
  "guest.scheduledVisit.success.body": "Payment completed. This preorder is now in progress.",
  "guest.scheduledVisit.success.addItems": "Add more items",
  "guest.scheduledVisit.success.back": "Back to place",
  "guest.scheduledVisit.success.reservationNumber": "Reservation #",
  "guest.scheduledVisit.success.date": "Date",
  "guest.scheduledVisit.success.time": "Time",
  "guest.scheduledVisit.success.place": "Place",
  "guest.scheduledVisit.success.waitlist": "Waitlist (table is not assigned yet)",
  "guest.scheduledVisit.success.guestName": "Guest name",
  "guest.scheduledVisit.success.preorderItems": "Preorder items",
  "guest.scheduledVisit.success.course": "Serving order {course}",
  "guest.scheduledVisit.success.subtotal": "Subtotal",
  "guest.scheduledVisit.success.paid": "Paid",
  "guest.scheduledVisit.success.remaining": "Remaining",
  "guest.scheduledUnified.common.loading": "Loading scheduled visit…",
  "guest.scheduledUnified.common.backToPlace": "Back to place",
  "guest.scheduledUnified.common.back": "Back",
  "guest.scheduledUnified.common.continue": "Continue",
  "guest.scheduledUnified.visit.title": "Scheduled visit",
  "guest.scheduledUnified.visit.subtitle": "Choose date, time, and table option",
  "guest.scheduledUnified.visit.merchantFallback": "Merchant",
  "guest.scheduledUnified.visit.dateLabel": "Date",
  "guest.scheduledUnified.visit.guestsLabel": "Guests",
  "guest.scheduledUnified.visit.durationLabel": "Duration (min)",
  "guest.scheduledUnified.visit.availableTimeLabel": "Available time",
  "guest.scheduledUnified.visit.noSlots": "No slots for selected date.",
  "guest.scheduledUnified.visit.noTableAssigned": "Table is not assigned yet. Waiter will assign table before preorder screen is available.",
  "guest.scheduledUnified.cart.title": "Cart",
  "guest.scheduledUnified.cart.stepHint": "Cart step is ready. You will add items right after reservation confirmation.",
  "guest.scheduledUnified.cart.existingCount": "Existing local carts: {count}",
  "guest.scheduledUnified.cart.empty": "No items yet.",
  "guest.scheduledUnified.cart.preorderTitle": "Preorder cart",
  "guest.scheduledUnified.cart.summary": "{count} items • {total}",
  "guest.scheduledUnified.cart.chooseProduct": "Choose product",
  "guest.scheduledUnified.cart.course": "Serving order {value}",
  "guest.scheduledUnified.cart.remove": "Remove",
  "guest.scheduledUnified.cart.edit": "Edit",
  "guest.scheduledUnified.cart.menuTitle": "Menu",
  "guest.scheduledUnified.cart.menuSubtitle": "Pick items for preorder",
  "guest.scheduledUnified.cart.menuSearchPlaceholder": "Search dishes",
  "guest.scheduledUnified.cart.menuEmpty": "Nothing found",
  "guest.scheduledUnified.cart.menuInCart": "In cart: {count}",
  "guest.scheduledUnified.cart.addItem": "Add item",
  "guest.scheduledUnified.cart.itemFallback": "Item",
  "guest.scheduledUnified.cart.dialogDescription": "Configure item details before adding it to your cart.",
  "guest.scheduledUnified.cart.quantityLabel": "Quantity",
  "guest.scheduledUnified.cart.courseLabel": "Serving order",
  "guest.scheduledUnified.cart.commentLabel": "Comment",
  "guest.scheduledUnified.cart.commentPlaceholder": "Comment for kitchen / waiter",
  "guest.scheduledUnified.cart.cancel": "Cancel",
  "guest.scheduledUnified.cart.updateItem": "Update item",
  "guest.scheduledUnified.cart.addToCart": "Add to cart",
  "guest.scheduledUnified.review.title": "Review",
  "guest.scheduledUnified.review.cta.bookAndPay": "Book and pay",
  "guest.scheduledUnified.review.date": "Date: {value}",
  "guest.scheduledUnified.review.time": "Time: {value}",
  "guest.scheduledUnified.review.guests": "Guests: {value}",
  "guest.scheduledUnified.review.duration": "Duration: {value} min",
  "guest.scheduledUnified.review.guestNameLabel": "Name",
  "guest.scheduledUnified.review.guestNamePlaceholder": "Your name",
  "guest.scheduledUnified.review.guestEmailLabel": "Email",
  "guest.scheduledUnified.review.guestEmailPlaceholder": "you@example.com",
  "guest.scheduledUnified.review.guestPhoneLabel": "Phone",
  "guest.scheduledUnified.review.guestPhonePlaceholder": "+371...",
  "guest.scheduledUnified.review.termsPrefix": "I accept",
  "guest.scheduledUnified.review.termsLink": "Terms and conditions",
  "guest.scheduledUnified.review.privacyLink": "Privacy policy",
  "guest.scheduledUnified.review.publicOfferLink": "Public offer",
  "guest.scheduledUnified.review.andWord": "and",
  "guest.scheduledUnified.review.personalDataPrefix": "I consent to",
  "guest.scheduledUnified.review.personalDataLink": "personal data processing",
  "guest.scheduledUnified.pay.title": "Payment",
  "guest.scheduledUnified.pay.cta.start": "Start payment",
  "guest.scheduledUnified.pay.cta.processing": "Processing…",
  "guest.scheduledUnified.waitlist.prompt": "No tables available. Join waitlist?",
  "guest.scheduledUnified.waitlist.join": "Join waitlist",
  "guest.scheduledUnified.waitlist.changeTime": "Change time",
  "guest.scheduledUnified.waitlist.created": "Waitlist request created.",
  "guest.scheduledUnified.featured.title": "Top picks",
  "guest.scheduledUnified.featured.priceOnRequest": "Price on request",
  "guest.scheduledUnified.result.successTitle": "Booking and preorder confirmed",
  "guest.scheduledUnified.result.successBody": "Confirmation has been sent by email.",
  "guest.scheduledUnified.result.failureTitle": "Payment was not completed",
  "guest.scheduledUnified.result.failureBody": "Your booking was canceled. Please try again.",
  "guest.scheduledUnified.failure.code": "Failure code: {value}",
  "guest.scheduledUnified.failure.noChargeHint": "If your bank showed a hold, it will be released automatically by your bank policy.",
  "guest.scheduledUnified.failure.changeTime": "Choose another time",
  "guest.scheduledUnified.failure.retry": "Try again",
  "guest.scheduledUnified.steps.visit": "Visit",
  "guest.scheduledUnified.steps.cart": "Cart",
  "guest.scheduledUnified.steps.review": "Review",
  "guest.scheduledUnified.errors.loadFailed": "Failed to load scheduled visit.",
  "guest.scheduledUnified.errors.tokenMissing": "Magic link token is missing.",
  "guest.scheduledUnified.errors.merchantMissing": "Merchant is missing in widget URL.",
  "guest.scheduledUnified.errors.createDraftFailed": "Failed to create draft.",
  "guest.scheduledUnified.errors.invalidGuestName": "Name is required.",
  "guest.scheduledUnified.errors.invalidGuestEmail": "Enter a valid email.",
  "guest.scheduledUnified.errors.invalidGuestPhone": "Enter a valid phone number.",
  "guest.scheduledUnified.errors.selectTimeRequired": "Select visit time first.",
  "guest.scheduledUnified.errors.selectDishRequired": "Fill your cart with everything needed so we can prepare it by your visit time.",
  "guest.scheduledUnified.errors.termsNotAccepted": "Accept terms, privacy policy, and public offer to continue.",
  "guest.scheduledUnified.errors.personalDataConsentRequired": "Personal data processing consent is required.",
  "guest.errors.productStopped": "Some items are no longer available. Refresh the menu and remove unavailable items from your cart.",
  "guest.unified.openOrders.title": "Open orders",
  "guest.unified.openOrders.subtitle": "Choose what to pay or add items",
  "guest.unified.queue.title": "Cart",
  "guest.unified.queue.subtitle": "Your selected items and preorder status",
  "guest.unified.queue.open": "Open queue",
  "guest.unified.queue.close": "Close queue",
  "guest.unified.queue.addNewPurchase": "Add new purchase",
  "guest.unified.queue.addToOrder": "Add to order",
  "guest.unified.queue.placeOrder": "Place order",
  "guest.unified.queue.removeSelected": "Remove selected",
  "guest.unified.queue.status.cart": "Cart",
  "guest.unified.queue.status.notSent": "Not sent yet",
  "guest.unified.queue.status.inProgress": "In progress",
  "guest.unified.queue.status.accepted": "Accepted",
  "guest.unified.queue.edit": "Edit",
  "guest.unified.queue.cancel": "Cancel",
  "guest.unified.queue.movedToCart": "Moved to cart for edit",
  "guest.unified.queue.canceled": "Preorder canceled",
  "guest.unified.queue.actions": "Actions",
  "guest.stepper.select": "Select",
  "guest.stepper.amount": "Amount",
  "guest.stepper.tip": "Tip",
  "guest.stepper.pay": "Pay",
  "guest.stepper.done": "Done",
  "guest.order.openedAt": "Opened {time}",
  "guest.order.paid": "Paid",
  "guest.order.remaining": "Left",
  "guest.order.itemsLabel": "items",
  "guest.order.hideFullList": "Hide",
  "guest.order.moreItems": "+{count} more",
  "guest.order.notPayable": "Not payable",
  "guest.order.leaveTip": "Leave a tip",
  "guest.postVisitTip.notice": "You're leaving a post-visit tip for {orderLabel}.",
  "guest.postVisitTip.min": "Minimum card tip is 1.00 {currency}.",
  "guest.postVisitTip.success.title": "Tip received, thank you!",
  "guest.postVisitTip.statusLabel": "Tip payment status",
  "guest.postVisitTip.status.pending": "Pending",
  "guest.postVisitTip.status.processing": "Processing",
  "guest.postVisitTip.status.requiresAction": "Action required",
  "guest.postVisitTip.status.succeeded": "Succeeded",
  "guest.postVisitTip.status.failed": "Failed",
  "guest.postVisitTip.status.canceled": "Canceled",
  "guest.footer.orderedTotal": "Ordered",
  "guest.footer.inCart": "Cart",
  "guest.footer.cartTotal": "Cart total",
  "guest.footer.selected": "Selected",
  "guest.footer.payingNow": "Paying now",
  "guest.footer.payer": "Payer",
  "guest.footer.remainingAfter": "Left after",
  "guest.checkout.reconcile.updatedSelection": "Selection updated. Only available orders are payable.",
  "guest.checkout.reconcile.continue": "Continue",
  "guest.footer.tip": "Tip",
  "guest.footer.total": "Total",
};

export default guestEn;
